import React from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'gatsby';

// import arrow from '../../images/arrow.svg';
import './HoverCard.scss';

const HoverCard = ({ title, image, imageWidth, bgGradient, children }) => (
  <div className={`hover-card col col-4 ${bgGradient ? 'bg-gradient' : ''}`}>
    <div>
      <h2 className="title">{title}</h2>
      <p className="content">{children}</p>
    </div>
    <div className="image-wrap">
      <img className="card-image" src={image} width={imageWidth} alt="" />
    </div>

    {/* <Link to="/" className="learn-more">
      Learn More
      <img src={arrow} alt="" />
    </Link> */}
  </div>
);

HoverCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  bgGradient: PropTypes.bool,
  children: PropTypes.node,
  imageWidth: PropTypes.string,
};

export default HoverCard;
